import { API_DATE_FORMAT, format } from '../../../../utils';
export function transformSegmentToParams(segment) {
    var _a;
    return {
        date: format((_a = segment.selectedDate) !== null && _a !== void 0 ? _a : segment.date, API_DATE_FORMAT),
        departure: { iata: segment.departure.iata },
        arrival: { iata: segment.arrival.iata }
    };
}
